import * as actionTypes from '../actionTypes/GridListActionTypes';

export const setTableRecordsAction = (tableRecordsData)=>{
	return{
		type:actionTypes.SET_TABLE_RECORDS,
		payload:tableRecordsData
	}
}
export const updateTableRecordsAction = (keyObj,data)=>{
	return{
		type:actionTypes.UPDATE_TABLE_RECORDS,
		payload:{
            keyObj:keyObj,
            data:data
        }
	}
}
export const resetTableRecordsAction = (obj)=>{
	return{
		type:actionTypes.RESET_TABLE_RECORDS,
		payload:{
			params:obj
		}
	}
}

export const setLookupFieldsRecord = (payload)=>{
	return{
		type:actionTypes.SET_LOOKUP_FIELDS_RECORDS,
		payload:payload
	}
} 